import Cookies from "universal-cookie";
import { authHelpers } from "./auth-helpers";
import { GUserProfile } from "@/app/login/components/google-signup";
import { getXPartner, isMTDomain } from "@/app/utils/helper";

interface Headers {
    [key: string]: string;
}

interface AuthPayload {
    cCode?: string;
    mobile?: string;
    source?: string;
    generateOtp?: boolean;
    captchaToken?: string;
    [key: string]: string | boolean | undefined;
    email?: string;
    name?: string;
    refCode?: string;
}

interface FeedbackPayload {
    qId: string;
    feedback: {
        npsFeedback: string[];
        status: string;
        surveyDate: number;
    };
}

export const authService = {
    logout,
    getAuthStatus,
    switchUser,
    otpAuthGetRequest,
    getUserDetails,
    registerWithOtp,
    loginWithOtp,
    verifyOtp,
    verifyOtpWithLogin,
    updateEmail,
    userEmailVerifyGet,
    userEmailVerifyPost,
    submitFeedback,
    fetchGoogleAuthUserDetails,
    verifyEmail,
    login,
    registerForGmail,
    resendOtpApi
};

function fetchGoogleAuthUserDetails(access_token: string) {
    // debugger;
    return fetch("https://www.googleapis.com/oauth2/v3/userinfo?access_token=" + access_token);
}

async function verifyEmail(email: string) {
    // debugger;
    const request = {
        email: email,
    };
    const requestOptions = {
        method: "POST",
        headers: { 
            "Content-Type": "application/json",
            "X-partner": isMTDomain() ? getXPartner() : "",
         },
        body: JSON.stringify(request),
    };
    const response = await fetch(
        `${process.env.API_BASE_URL}/auth/isExisitingUser`,
        requestOptions,
    ).then((result) => {
        return result.json();
    });
    return response;
}

async function login(request: { email: string | undefined; accessToken: string | undefined }) {
    const payLoad =
        "email=" +
        encodeURIComponent(String(request.email)) +
        "&access_token=" +
        encodeURIComponent(String(request.accessToken));
        const partnerId = typeof window !== "undefined" ? sessionStorage.getItem("partnerId") : null;

    const requestOptions: RequestInit = {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            ...(partnerId && { "X-partner": partnerId }),
        },
        body: payLoad + "&isAjax=true",
    };

    const response = await fetch(`${process.env.API_BASE_URL}/auth/login`, requestOptions)
        .then((response) => response.json())
        .then((authResponse) => {
            if (!authResponse.success || authResponse.message !== 1) {
                //Set error state and handle it
                const error = { success: false };
                return error;
            }
            //Set the auth cookie
            setAuthCookie(true, 1);
            //Return success.
            return authResponse;
        });
    return response;
}

async function registerForGmail(profile: GUserProfile) {
    // debugger;
    const request = {
        access_token: profile.accessToken,
        email: profile.email,
        familyName: profile.family_name,
        givenName: profile.given_name,
        id: profile.sub,
        name: profile.name,
        photo: profile.picture,
        source: "iosApp",
        userSwitch: true,
        refCode: profile?.refCode
    };

    const requestOptions = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-partner": isMTDomain() ? getXPartner() : "",
        },
        body: JSON.stringify(request),
    };

    const response = fetch(process.env.API_BASE_URL + "/users/v2/userEmailVerify", {...requestOptions, credentials: "include"})
        .then((response) => response.json())
        .then((authResponse) => {
            // console.log(authResponse);
            if (!authResponse.success || authResponse.message !== 1) {
                //Set error state and handle it
                const error = { success: false }; //authHelpers.getSignupError(authResponse.message);
                return error;
            }
            //Return success.
            return authResponse;
        });
    return response;
}

function setAuthCookie(value: boolean, numberOfDays: number) {
    const cookies = new Cookies();
    const date = new Date();
    date.setTime(date.getTime() + numberOfDays * 24 * 60 * 60 * 1000);
    cookies.set("AUTH", value, { expires: date, path: "/" });
}

async function getAuthStatus(): Promise<boolean> {
    const requestOptions: RequestInit = {
        method: "GET",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "X-partner" : getXPartner(),
        },
    };

    try {
        const response = await fetch(`${process.env.API_BASE_URL}/authStatus`, requestOptions);
        const authResponse = await response.json();
        // console.log(authResponse);
        return !!(authResponse.state && authResponse.email);
    } catch (error) {
        console.error("Auth status check failed", error);
        return false;
    }
}

function updateEmail(payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/users/updateUserEmail", {}, payload);
}

function switchUser() {
    return authHelpers.otpAuthGetRequest("/users/getUserEmail?userSwitch=true", { "X-partner": getXPartner() });
}

function getUserDetails() {
    return authHelpers.otpAuthGetRequest("/users/getUserEmail", { "X-partner": getXPartner() });
}

function userEmailVerifyGet() {
    return authHelpers.otpAuthGetRequest("/users/v2/userEmailVerify", {});
}

function userEmailVerifyPost(payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/users/userEmailVerify", {}, payload);
}

async function otpAuthGetRequest<T>(url: string, headers: Headers = {}): Promise<T> {
    const partnerId = typeof window !== "undefined" ? sessionStorage.getItem("partnerId") : null;
    const partner = partnerId || "orowealth";

    const requestHeaders: Headers = {
        ...headers,
        "Content-Type": "application/json",
        "X-partner": partner,
    };

    const requestOptions: RequestInit = {
        method: "GET",
        headers: requestHeaders,
        credentials: "include",
    };

    const response = await fetch(`${process.env.API_BASE_URL}${url}`, requestOptions);
    return response.json() as Promise<T>;
}

function registerWithOtp(payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/auth/register", {}, payload);
}

function loginWithOtp(payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/auth/login", {}, payload);
}

function verifyOtpWithLogin(payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/auth/login", {}, payload);
}

function resendOtpApi (payload: AuthPayload) {
    return authHelpers.otpAuthPostRequest("/auth/resendOtp",  {}, payload);
}

function verifyOtp(params: AuthPayload) {
    const queryParam = Object.keys(params)
        .map((key) => key + "=" + params[key])
        .join("&");
    return authHelpers.otpAuthGetRequest("/auth/verify?" + queryParam, {});
}

function submitFeedback(payload: FeedbackPayload) {
    const header = {
        "X-product": `orobonds:default`,
    };
    return authHelpers.waitlistAuthPostRequest("/nps/feedback", header, {}, payload);
}

function logout() {
    return authHelpers.otpAuthPostRequest("/auth/logout", {}, {});
}
